export const EventEmailTemplateType = {
  REMINDER: 'REMINDER',
  APPROVAL: 'APPROVAL',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
};

export const eventEmailTemplateTypes = [
  EventEmailTemplateType.REMINDER,
  EventEmailTemplateType.APPROVAL,
  EventEmailTemplateType.REJECTED,
  EventEmailTemplateType.CANCELLED,
];
